import React from 'react'

import { Button, Modal } from '@resurs/midas-react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { getText } from '../../internal/TextLabels'
import { DelayedPaymentSignPageUI } from '../PayApply/pages/ApplicationSignPage/UI/DelayedPaymentSignPageUI'
import { calculateLinkExpirationDate } from '../../util/dateUtils'
import { resendSigning } from '../../store/actions/pay-apply-signing-actions'

const OngoingPaymentsResendSigningLinkModal = ({
  selectedTransaction: { date, id, customer, payment, store },
  signingLinkInfo,
  setSigningLinkInfo,
  setShowModal,
  resendSigningToCustomer,
}) => {
  const calculatedLinkExpirationDate = calculateLinkExpirationDate(date)

  return (
    <Modal
      title={
        <div style={{ fontWeight: 'bold', paddingLeft: '1rem', margin: 0 }}>
          {getText('payApply.sign.delayedPayment.resendTitle')}
        </div>
      }
      onClose={() => setShowModal(false)}
      show
    >
      <div style={{ margin: '1rem' }}>
        {customer && (
          <div style={{ width: '100%', height: '100%' }}>
            <DelayedPaymentSignPageUI
              customer={customer}
              paymentId={payment.id}
              onChange={setSigningLinkInfo}
            >
              <>
                <h5>{getText('payApply.sign.delayedPayment.messageTitle')}</h5>
                {getText('payApply.sign.delayedPayment.message', {
                  storeName: store.storeName,
                })}
                <div>
                  <h5>
                    {getText('payApply.sign.delayedPayment.expirationTitle')}
                  </h5>
                  <p>{calculatedLinkExpirationDate}</p>
                </div>
                <div
                  style={{
                    display: 'flex',
                    width: '100%',
                    padding: '3rem 0 1rem',
                  }}
                >
                  <Button
                    id="delayed-payment-cancel-btn"
                    type="normal"
                    onClick={() => setShowModal(false)}
                  >
                    {getText('payApply.cancel')}
                  </Button>
                  <div
                    style={{
                      display: 'inline-flex',
                      width: '100%',
                      justifyContent: 'flex-end',
                    }}
                  >
                    <Button
                      id="delayed-payment-sign-btn"
                      type="primary"
                      disabled={!signingLinkInfo.valid}
                      autoFocus
                      onClick={() => {
                        resendSigningToCustomer(id, signingLinkInfo, () =>
                          setShowModal(false),
                        )
                      }}
                    >
                      {getText('payApply.sign.delayedPayment.sendLink')}
                    </Button>
                  </div>
                </div>
              </>
            </DelayedPaymentSignPageUI>
          </div>
        )}
      </div>
    </Modal>
  )
}

OngoingPaymentsResendSigningLinkModal.propTypes = {
  selectedTransaction: PropTypes.shape({
    date: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    customer: PropTypes.object.isRequired,
    payment: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired,
  }).isRequired,
  signingLinkInfo: PropTypes.shape({
    email: PropTypes.string,
    mobile: PropTypes.string,
  }).isRequired,
  setSigningLinkInfo: PropTypes.func.isRequired,
  setShowModal: PropTypes.func.isRequired,
  resendSigningToCustomer: PropTypes.func.isRequired,
}

const mapDispatchToProps = dispatch => ({
  resendSigningToCustomer: (paymentId, customer, successfulAction) =>
    dispatch(resendSigning({ paymentId, customer }, successfulAction)),
})

export default connect(
  null,
  mapDispatchToProps,
)(OngoingPaymentsResendSigningLinkModal)
